export default __webpack_public_path__ + "static/media/Equipe4.ad6e471a.png";